import React, { FC } from 'react';
import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import {
  BannerExpandProps,
  BannerProps,
  TBannerSeverity,
} from './Banner.types';
import {
  BannerContainer,
  BannerExpandContent,
  BannerExpandLabel,
  DropdownExpandIcon,
} from './Banner.styles';
import styled from 'styled-components';

const iconNameByBannerSeverity: Record<TBannerSeverity, TrevorIconName> = {
  error: 'error',
  warning: 'warning',
  success: 'check-circle',
  info: 'info',
};

export const Banner: FC<BannerProps> = ({
  severity,
  onClose,
  children,
  ...props
}) => {
  return (
    <BannerContainer severity={severity} {...props}>
      <TrevorIcon name={iconNameByBannerSeverity[severity]} />
      <span>{children}</span>
      {onClose && <TrevorIcon name="close-circle" onClick={onClose} />}
    </BannerContainer>
  );
};

const BannerExpandContainer = styled(Banner)`
  cursor: pointer;

  > span {
    width: 100%;
  }
`;

export const BannerExpand: FC<BannerExpandProps> = ({
  label,
  severity,
  children,
  expanded,
  onExpand,
  ...props
}) => {
  return (
    <BannerExpandContainer onClick={onExpand} severity={severity} {...props}>
      <BannerExpandLabel>
        {label}
        <DropdownExpandIcon $expanded={expanded} />
      </BannerExpandLabel>

      {expanded && (
        // TODO: Refactor this component and avoid the double br. Later
        <BannerExpandContent>
          <br />
          {children}
        </BannerExpandContent>
      )}
    </BannerExpandContainer>
  );
};
